import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { MenuSelectors } from "../../redux/selectors/index.js";
import { useDispatch, useSelector } from "react-redux";
import { MenuActionCreators } from "../../redux/action-creators/index.js";
import { MenuItem } from "./MenuItem.js";
import classNames from "classnames";
import { TrackingUtils } from "../../utils/index.js";

export const ExpandableSportCategoryMenuItem = props => {
  const { item, onClick, dataTestId, ...restProps } = props;
  const dispatch = useDispatch();
  const selectedItem = useSelector(MenuSelectors.selectedItem);
  const quickLinksInnerMenuVisible = useSelector(
    MenuSelectors.quickLinksInnerMenuVisible
  );
  const quickLinksInnerMenuItem = useSelector(
    MenuSelectors.quickLinksInnerMenuItem
  );

  const favouriteSports = useSelector(MenuSelectors.favouriteSports);
  const [isChildrenActive, setIsChildrenActive] = useState(false);
  const ignoreClass = `do-not-close-${dataTestId}`;

  useEffect(() => {
    const isActiveExpandableItem = (item, selectedItem, favouriteSports) => {
      if (!item) return false;
      if (selectedItem && item === selectedItem) return true;

      if (
        item.sportID &&
        selectedItem?.sportID &&
        item.sportID === selectedItem.sportID
      ) {
        return true;
      }

      if (
        favouriteSports?.find(
          favItem => favItem === item || favItem.sportID === item?.sportID
        )
      ) {
        return item?.sportID === selectedItem?.sportID;
      }

      if (!item.items || !item.items.length) return false;
      const children = item.items;
      return children.some(childItem =>
        isActiveExpandableItem(childItem, selectedItem, favouriteSports)
      );
    };

    setIsChildrenActive(
      isActiveExpandableItem(item, selectedItem, favouriteSports)
    );
  }, [favouriteSports, item, selectedItem]);

  const handleClick = e => {
    if (typeof onClick === "function" && onClick(e)) return;
    dispatch(MenuActionCreators.hideHamburgerMenu());
    if (quickLinksInnerMenuVisible) {
      dispatch(MenuActionCreators.hideQuickLinksInnerMenu());
    } else {
      dispatch(MenuActionCreators.showQuickLinksInnerMenu(item));
      dispatch(MenuActionCreators.setInnerMenuIgnoreClass(ignoreClass));
    }
    TrackingUtils.sendAnalytics({
      dataEvent: "UC_GENERIC_EVENT_important",
      dataCategory: "Menu",
      dataAction: "click",
      dataLabel: "Sports A-Z"
    });
  };

  return (
    <MenuItem
      item={item}
      dataTestId={dataTestId}
      className={classNames(
        { [restProps.className]: !!restProps.className },
        ignoreClass
      )}
      onClick={handleClick}
      isActive={
        (quickLinksInnerMenuVisible && quickLinksInnerMenuItem === item) ||
        isChildrenActive
      }
      hasArrow
      {...restProps}
    />
  );
};

ExpandableSportCategoryMenuItem.propTypes = {
  item: PropTypes.object,
  onClick: PropTypes.func,
  dataTestId: PropTypes.string.isRequired,
  ignoreClass: PropTypes.string
};
